const Navbar = () => {
  return (
    <header className=" main-site-header">
      <h1 className="main-site-heading">Todos App</h1>
    </header>
  );
};

export default Navbar;
